<template>
  <div
    class="bg-white rounded-xl relative w-full shadow transition-all duration-300 ease-in-out flex"
  >
    <!-- Pro Badge -->
    <div v-if="exhibitor.plan > 0" class="badge-wrapper text-white z-40">
      <div class="badge-square">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
          />
        </svg>
      </div>
      <div class="flex justify-between relative bottom-px lg:bottom-0">
        <div class="badge-left-point"></div>
        <div class="badge-right-point"></div>
      </div>
    </div>

    <!-- Main -->
    <div class="relative z-10 rounded-l-xl overflow-hidden flex w-full">
      <div class="z-10 w-72">
        <div
          :style="[
            exhibitor.plan > 0
              ? { backgroundImage: 'url(' + exhibitor.banner + ')' }
              : {},
            { backgroundColor: '#F7F7F7' },
          ]"
          class="bg-no-repeat bg-cover bg-center relative w-full h-full text-white flex items-center justify-center flex-col rounded-l-xl"
        >
          <img
            v-if="exhibitor.logo"
            :style="{
              maxwidth: '150px',
            }"
            :src="exhibitor.logo"
            alt="Exhibitor Logo"
            class="w-1/2"
          />
          <img
            v-if="!exhibitor.logo"
            :style="{
              maxwidth: '150px',
            }"
            src="/img/careers-expo-basic-exhibitor.png"
            alt="Exhibitor Logo"
            class="w-1/2"
          />
        </div>
      </div>

      <!-- Details -->
      <div
        :style="{ width: 'calc(100% - 18rem)' }"
        class="h-full bg-white p-6 pt-12 rounded-r-xl"
      >
        <h5
          v-if="exhibitor.categories[0] && exhibitor.categories[0].title"
          class="font-primary font-semibold text-xs text-expo_dblue uppercase mb-2"
        >
          {{ exhibitor.categories[0].title }}
        </h5>
        <h5
          v-if="exhibitor.profile_title"
          class="font-secondary font-normal mb-8"
        >
          {{ exhibitor.profile_title }}
        </h5>
        <p
          v-if="exhibitor.profile_description"
          :id="exhibitor.id + '-exhibitorDesc'"
          :style="{ maxHeight: '440px' }"
          :class="isOverflowing ? 'mb-2' : 'mb-8'"
          class="overflow-hidden text-sm relative z-10"
          v-html="exhibitor.profile_description"
        ></p>
        <p
          v-if="isOverflowing"
          class="menu-overflow relative mb-8 z-20 text-xs text-truegray-500"
        >
          Read more on their profile below.
        </p>
        <div class="text-expo_dblue flex flex-col space-y-1">
          <div
            v-if="exhibitor.statistics && exhibitor.plan > 0"
            class="flex flex-wrap text-sm"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 mr-2"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"
              />
              <path
                d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"
              />
            </svg>
            Posts: {{ exhibitor.statistics.posts }}
          </div>
          <div
            v-if="exhibitor.contact_email"
            class="flex flex-wrap text-sm font-normal"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 mr-2"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M14.243 5.757a6 6 0 10-.986 9.284 1 1 0 111.087 1.678A8 8 0 1118 10a3 3 0 01-4.8 2.401A4 4 0 1114 10a1 1 0 102 0c0-1.537-.586-3.07-1.757-4.243zM12 10a2 2 0 10-4 0 2 2 0 004 0z"
                clip-rule="evenodd"
              />
            </svg>
            {{ exhibitor.contact_email }}
          </div>
          <div
            v-if="exhibitor.website"
            class="flex flex-wrap text-sm font-normal"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 mr-2"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M4.083 9h1.946c.089-1.546.383-2.97.837-4.118A6.004 6.004 0 004.083 9zM10 2a8 8 0 100 16 8 8 0 000-16zm0 2c-.076 0-.232.032-.465.262-.238.234-.497.623-.737 1.182-.389.907-.673 2.142-.766 3.556h3.936c-.093-1.414-.377-2.649-.766-3.556-.24-.56-.5-.948-.737-1.182C10.232 4.032 10.076 4 10 4zm3.971 5c-.089-1.546-.383-2.97-.837-4.118A6.004 6.004 0 0115.917 9h-1.946zm-2.003 2H8.032c.093 1.414.377 2.649.766 3.556.24.56.5.948.737 1.182.233.23.389.262.465.262.076 0 .232-.032.465-.262.238-.234.498-.623.737-1.182.389-.907.673-2.142.766-3.556zm1.166 4.118c.454-1.147.748-2.572.837-4.118h1.946a6.004 6.004 0 01-2.783 4.118zm-6.268 0C6.412 13.97 6.118 12.546 6.03 11H4.083a6.004 6.004 0 002.783 4.118z"
                clip-rule="evenodd"
              />
            </svg>
            <a
              class="text-sm font-normal font-secondary"
              :href="exhibitor.website"
              target="_blank"
              >{{ exhibitor.website }}</a
            >
          </div>
          <div
            v-if="exhibitor.contact_telephone"
            class="flex flex-wrap text-sm font-normal"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 mr-2"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"
              />
            </svg>
            <a
              class="text-sm font-normal font-secondary"
              :href="'tel:' + exhibitor.contact_telephone"
              target="_blank"
              >{{ exhibitor.contact_telephone }}</a
            >
          </div>
          <div
            v-if="exhibitor.regions && exhibitor.regions.length > 0"
            class="flex items-start"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 mr-2 flex-shrink-0"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                clip-rule="evenodd"
              />
            </svg>
            <div class="flex flex-wrap">
              <div
                v-for="(region, i) in exhibitor.regions"
                :key="i"
                :ref="'region-' + i"
                class="region relative mr-4 text-sm"
              >
                {{ region.title }}
              </div>
            </div>
          </div>
        </div>

        <!-- Card base -->
        <div class="mt-4 flex justify-between">
          <div
            v-if="exhibitor.plan > 0"
            class="self-end w-full self-end w-full mt-auto relative z-40 bg-white rounded-xl w-1/4"
          >
            <div class="flex justify-betweenmx-4">
              <a
                ref="tenantUrl"
                class="hidden"
                target="_blank"
                :href="exhibitor.site_url"
              ></a>
              <h5
                class="uppercase detail-button ease-in-out relative flex items-center font-semibold cursor-pointer font-primary text-sm text-expo_red"
                @click="viewProfile(exhibitor.id)"
              >
                View Profile
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4 transition-all duration-300 detail-arrow"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clip-rule="evenodd"
                  />
                </svg>
              </h5>
            </div>
          </div>
          <div class="w-3/4 flex flex-col items-end">
            <div
              v-if="exhibitor.events.length > 0"
              class="flex items-center mb-2"
            >
              <img
                src="/img/expo_symbol_navy.png"
                alt="Careers Expo logo"
                class="h-4 opacity-30 mr-4"
              />
              <h5
                class="text-right font-primary font-semibold text-xs text-expo_dblue uppercase m-0"
              >
                Expos Attending
              </h5>
            </div>
            <div
              v-if="exhibitor.events.length > 0"
              class="flex flex-wrap items-center justify-end"
            >
              <div
                v-for="(expo, i) in exhibitor.events"
                :key="i"
                :ref="'expo-' + i"
                class="region relative ml-4 text-xs text-right"
              >
                {{ expo.title }}
              </div>
            </div>
            <div v-else class="flex space-x-4 items-center">
              <h5
                class="font-primary font-semibold text-xs text-expo_dblue uppercase m-0"
              >
                Online Only
              </h5>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 w-4 text-expo_dblue"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M4.083 9h1.946c.089-1.546.383-2.97.837-4.118A6.004 6.004 0 004.083 9zM10 2a8 8 0 100 16 8 8 0 000-16zm0 2c-.076 0-.232.032-.465.262-.238.234-.497.623-.737 1.182-.389.907-.673 2.142-.766 3.556h3.936c-.093-1.414-.377-2.649-.766-3.556-.24-.56-.5-.948-.737-1.182C10.232 4.032 10.076 4 10 4zm3.971 5c-.089-1.546-.383-2.97-.837-4.118A6.004 6.004 0 0115.917 9h-1.946zm-2.003 2H8.032c.093 1.414.377 2.649.766 3.556.24.56.5.948.737 1.182.233.23.389.262.465.262.076 0 .232-.032.465-.262.238-.234.498-.623.737-1.182.389-.907.673-2.142.766-3.556zm1.166 4.118c.454-1.147.748-2.572.837-4.118h1.946a6.004 6.004 0 01-2.783 4.118zm-6.268 0C6.412 13.97 6.118 12.546 6.03 11H4.083a6.004 6.004 0 002.783 4.118z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
          </div>
        </div>
        <!-- /Card base -->
      </div>
    </div>
  </div>
</template>

<script>
import * as loadingAnimation from '../../../shared/components/loading.json'

export default {
  props: {
    exhibitor: { default: [] },
  },

  data() {
    return {
      loadingAnimationOptions: { animationData: loadingAnimation.default },
      loadingAnimate: false,

      saved: false,
      loaded: false,
      thinking: false,
      detailsActive: false,
      isOverflowing: false,
    }
  },

  mounted() {
    setTimeout(() => {
      this.checkOverflow()
    }, 10)
  },

  created() {
    window.addEventListener('resize', this.checkOverflow)
  },

  unmounted() {
    window.removeEventListener('resize', this.checkOverflow)
  },

  methods: {
    viewProfile() {
      this.$refs.tenantUrl.click()
    },

    checkOverflow() {
      let overflowDesc = document.getElementById(
        this.exhibitor.id + '-exhibitorDesc',
      )
      if (overflowDesc) {
        let overflowing =
          overflowDesc.scrollHeight - overflowDesc.clientHeight > 1
        this.$set(this, 'isOverflowing', overflowing)
      }
    },
  },
}
</script>

<style scoped>
.menu-overflow:after {
  width: 100%;
  height: 20px;
  content: '';
  position: absolute;
  bottom: 24px;
  left: 0;
  background: linear-gradient(
    0deg,
    rgba(255, 255, 255, 1) 25%,
    rgba(255, 255, 255, 0) 100%
  );
}

.detail-button:hover .detail-arrow {
  transform: translateX(4px);
}

.region::after {
  position: absolute;
  content: '';
  top: 50%;
  right: -9px;
  transform: translateY(-50%);
  width: 2px;
  height: 2px;
  border-radius: 50%;
  background: #00172f;
}

.region:last-child::after {
  display: none;
}

.badge-wrapper {
  position: absolute;
  top: -8px;
  right: 10%;
}

.badge-square {
  width: 40px;
  height: 40px;
  background: #fe4a49;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.badge-square::before {
  position: absolute;
  content: '';
  right: -8px;
  top: 0;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 8px 0 0 8px;
  border-color: transparent transparent transparent #9e2020;
}

.badge-square::after {
  position: absolute;
  content: '';
  top: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background: #fb7777;
}

.badge-left-point {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 20px 20px 0 0;
  border-color: #fe4949 transparent transparent transparent;
}

.badge-right-point {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 20px 20px 0;
  border-color: transparent #fe4949 transparent transparent;
}
</style>
